import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';

type FontWeight = 'normal' | 'light' | 'bold';

const weights: Record<FontWeight, number> = {
  normal: 500,
  light: 400,
  bold: 700,
};

type Variant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2';

type Props = TypographyProps & {
  size?: 12 | 14 | 16 | 20 | 24;
  variant?: Variant;
  weight?: FontWeight;
  uppercase?: boolean;
  children: React.ReactNode;
};

const Text = ({
  size = 14,
  variant = 'body1',
  weight = 'normal',
  uppercase = false,
  children,
  ...props
}: Props) => {
  const isHeadline = variant !== 'body1' && variant !== 'body2';
  return (
    <Typography
      {...props}
      variant={variant}
      sx={[
        {
          fontSize: size,
          fontWeight: weights[weight],
          textTransform: uppercase ? 'uppercase' : 'none',
          fontFamily: isHeadline
            ? 'Sandvik Sans Headline'
            : 'Sandvik Sans Text',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {children}
    </Typography>
  );
};

export default Text;
